export default __webpack_public_path__ + "static/media/technological-disaster.a5360343.svg";